export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;
export const API_DOMAIN_IMG = process.env.REACT_APP_API_DOMAIN_IMG;

//export const API_DOMAIN = 'http://localhost/backend/TradeFixNew'
//export const API_DOMAIN_IMG = 'http://localhost:3000'
//export const API_DOMAIN = "https://localhost:7223";

